import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SearchTextButton, SearchTextModal, SearchTextModalListing } from '../../../components/SearchText';
import { getSearchText } from '../../../selectors/filters';
import { getIsLoading, hasNotItems } from '../../../selectors/listing';
import { TThunkDispatch } from '../../../types/redux';
import { ListingContainer } from '../../ListingContainer';
import { PaginationContainer } from '../../PaginationContainer';
import { TotalCountTextContainer } from '../../TotalCountTextContainer';
import { SearchTextInputContainer } from './SearchTextInputContainer';
import { useSetSearchTextHandler } from '../../../hooks/useSetSearchTextHandler';
import { useGetListingHandler } from '../../../hooks/useGetListingHandler';

export function SearchTextButtonContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isSearchHistoryOpen, setSearchHistoryOpen] = React.useState(false);

  const searchText = useSelector(getSearchText);
  const isLoading = useSelector(getIsLoading);
  const setSearchText = useSetSearchTextHandler();
  const getListing = useGetListingHandler();
  const isEmpty = useSelector(hasNotItems);

  const openModal = React.useCallback(() => setIsOpen(true), []);
  const closeModal = React.useCallback(async () => {
    dispatch(setSearchText(undefined));
    setIsOpen(false);
    await dispatch(getListing(1));
  }, [dispatch, getListing, setSearchText]);

  // Пустые deps, чтобы вызвался только 1 раз, во время маунта компонента
  React.useEffect(() => {
    if (searchText) {
      setIsOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SearchTextButton onClick={openModal} />
      <SearchTextModal
        searchTextFilter={
          <SearchTextInputContainer inputWidth="100%" onHistoryListOpenChanged={setSearchHistoryOpen} />
        }
        content={
          !isSearchHistoryOpen && (
            <SearchTextModalListing
              isEmpty={isEmpty}
              isLoading={isLoading}
              totalCountsText={<TotalCountTextContainer />}
              listing={<ListingContainer />}
              pagination={<PaginationContainer />}
            />
          )
        }
        isOpen={isOpen}
        onClose={closeModal}
      />
    </>
  );
}
